module.exports = __webpack_public_path__ + "static/media/warning.98f0a0b3.svg";